module.exports = __webpack_public_path__ + "img/tourism.5da5a206.png";